import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-reason"]
const _hoisted_2 = {
  class: "mt-0.5 h-4 w-4 shrink-0 text-neutral50",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = { "data-testid": "prefill-empty-state-text" }
const _hoisted_6 = { key: 0 }

import { computed } from 'vue'
import { mdiInformationOutline } from '@mdi/js'
import type { RouteLocationRaw } from 'vue-router'
import PATHS from '@/router/paths'
import type { DSAttendancePrefillEmptyReason } from '@/Network/Types/Responses/DsAttendancePolicyResponses'
import { buildPrefillEmptyState } from '../utils/prefill-empty-state'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendancePrefillEmptyState',
  props: {
    emptyReason: { default: null },
    scheduleName: { default: null },
    date: { default: null },
    shifts: { default: null },
    recurrence: { default: null },
    referenceDate: { default: null },
    scheduleId: { default: null }
  },
  setup(__props: any) {

const props = __props;



const emptyState = computed(() =>
  buildPrefillEmptyState({
    emptyReason: props.emptyReason,
    scheduleName: props.scheduleName,
    date: props.date,
    shifts: props.shifts,
    recurrence: props.recurrence
  })
)

/** Sem data ou sem escala não há para onde levar — o link simplesmente não aparece. */
const scheduleLink = computed<RouteLocationRaw | null>(() => {
  if (!props.referenceDate || props.scheduleId === null || props.scheduleId === undefined) {
    return null
  }
  return {
    path: PATHS.DASHBOARD,
    query: { startDate: props.referenceDate, schedules: String(props.scheduleId) }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (emptyState.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mb-3 flex items-start gap-2 rounded-lg border border-gray-300 bg-gray-50 p-3 text-sm text-textPrimary",
        "data-testid": "prefill-empty-state",
        "data-reason": emptyState.value.reason
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("path", {
            d: _unref(mdiInformationOutline),
            fill: "currentColor"
          }, null, 8, _hoisted_3)
        ])),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emptyState.value.segments, (segment, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (segment.strong)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString(segment.text), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(segment.text), 1)
                    ], 64))
              ], 64))
            }), 128))
          ]),
          (emptyState.value.showScheduleLink && scheduleLink.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: scheduleLink.value,
                class: "mt-1 inline-block font-bold text-primary underline",
                "data-testid": "prefill-empty-state-schedule-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ver escala do dia ")
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})